
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"},"content":"<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M20.5 4L25 8.52V26a2 2 0 01-2 2H9a2 2 0 01-2-2V6a2 2 0 012-2h11.5z\" fill=\"#F6C502\"/><path fill=\"#FFF\" d=\"M13.75 10.75h1.875V8.875H13.75zm1.875 1.875H17.5V10.75h-1.875zM13.75 14.5h1.875v-1.875H13.75zm1.875 1.875H17.5V14.5h-1.875zM13.75 18.25h1.875v-1.875H13.75zm0 3.75h3.75v-3.75h-3.75z\"/><path fill=\"#F6C502\" d=\"M14.688 21.063h1.874v-1.875h-1.875z\"/><path d=\"M20.5 4.002v3.501a1 1 0 001 1H25l-4.5-4.5z\" fill=\"#FFF\" opacity=\".5\"/></g>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
